import restClient from 'Shared/hooks/restClient'
import { v4 as uuidv4 } from 'uuid'
import { useMemo, useState, useEffect } from 'react'
import SanitizedHtml from 'Shared/components/SanitizedHtml'

const OVERRIDES = {
  paragraph_v2: '<center><i>Click here to add text</i></center>',
}

// Define conditions for when a block is considered "blank"
const isBlockBlank = (blockTemplate, parameters) => {
  const templateName = blockTemplate?.name || blockTemplate

  switch (templateName) {
    case 'paragraph_v2':
      return parameters?.text === ''
    default:
      return false
  }
}

export default function StaticBlock({ block, blockTemplate, active }) {
  const [html, setHtml] = useState('<span>Loading...</span>')
  const campaignId = useSel(s => s.campaign.id)
  const styles = useSel(s => s.emailBuilder.styles)

  // Generate a stable scope ID
  const scopeId = useMemo(() => uuidv4(), [])

  // Scope styles to the unique class
  const scopeStyles = (css, scopeClass) => {
    return css.replace(/(^|}|;)\s*([^@{}]+)\s*{/g, (match, boundary, selector) => {
      if (selector.trim().startsWith('@')) {
        return match; // Skip @ rules
      }
      const scopedSelector = selector
        .split(',')
        .map(s => `${scopeClass} ${s.trim()}`)
        .join(', ');
      return `${boundary} ${scopedSelector} {`;
    });
  };

  const scopedStyles = useMemo(() => scopeStyles(styles || '', `.scoped-${scopeId}`), [styles, scopeId]);

  const renderBlock = useMemo(() => {
    function renderBlock(block) {
      const templateName = blockTemplate?.name || blockTemplate

      // Check if block is blank based on its parameters
      if (block && isBlockBlank(blockTemplate, block.parameters)) {
        const overrideHtml = OVERRIDES[templateName]
        if (overrideHtml) {
          setHtml(overrideHtml)
          return
        }
      }

      // If not blank or no override exists, proceed with API call
      restClient.post('/api/render/render_block', { campaignId, block, blockTemplate, styles })
        .then(({ data }) => {
          setHtml(data.html)
        })
    }

    const dRenderBlock = _.debounce(renderBlock, 250)
    let firstCall = true

    // Remove lag on first load
    return (block) => {
      if (firstCall) {
        firstCall = false
        renderBlock(block)
      } else {
        dRenderBlock(block)
      }
    }
  }, [campaignId, blockTemplate, styles])

  useEffect(() => {
    renderBlock(block)
  }, [block, renderBlock])

  const memoHtml = useMemo(() => {
    return (
      <div className='wipe-css'>
        {/* Scoped styles — built from admin-controlled s.emailBuilder.styles, not tenant input */}
        <style dangerouslySetInnerHTML={{ __html: scopedStyles }}></style>
        <SanitizedHtml
          html={html}
          preset='email-block'
          className={`foundation-container scoped-${scopeId}`}
        />
      </div>
    )
  }, [html, scopedStyles, scopeId])

  if (active) return null

  return memoHtml
}